import React from 'react';
import './about.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhoneAlt,faEnvelope,faMapMarkerAlt,faHandsWash,faHandshakeSlash, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import Founder from '../images/company.JPG';



function About() {
  return <>
  <div className="home_static_container">
       <div className='home_touch_text'>Get In Touch</div>
  <div className='static_sm_container'>
       <a href="https://api.whatsapp.com/send?phone=+91 9092423735" rel="whatsapp icon">
            <FontAwesomeIcon icon={faWhatsapp} className="static_sm_icon static_whatsapp_icon" />
            </a>
      <a href="mailto:spsplandpromoters2021theni@gmail.com" rel="linked to mail">
      <FontAwesomeIcon icon={faEnvelope} className="static_sm_icon static_email_icon" />

      </a>
      <a href="tel:+91 9092423735" rel="linked to call">
       <FontAwesomeIcon icon={faPhoneAlt} className="static_sm_icon static_phone_icon" />
      </a>
  </div>
  </div>
  <div className='about_container' id="aboutus">
              <h2 className='whatwedo_heading'>WHAT WE DO.</h2>
       <div className='about_area'>
 {/* background image brightness */}
          <div className="what_wedo_background_controller">
                
            </div>
{/* background image */}
           <div className="what_wedo_background">

           </div>
           {/* about work content */}
           <div className="about_content_container">
               <div className="about_content">
               <h4>Plots For Sale</h4>
               <hr style={{padding:'2px',color:'#13151d'}} />
                <p>We are provide Plots, Approvals, Layout, HomeLoans for your dream house. Contact us for more information.
                     <button className='about_readmore_button'  onClick={()=> window.open("/about-us","_self")}>Read More</button>
                </p>
               </div> 

               <div className="about_content">
               <h4>2D, 3D Home Plans</h4>
               <hr style={{padding:'2px',color:'#13151d'}} />

                <p>We are providing Best 2D and 3D Plans for your Dream House. Plans will be accurate and modern solutions. Let's Contact us for more information.
                     <button className='about_readmore_button'  onClick={()=> window.open("/about-us","_self")}>Read More</button>
                </p>
               </div> 
           
               <div className="about_content">
               <h4>Road &#38; Construction Works</h4>
               <hr style={{padding:'2px',color:'#13151d'}} />
                <p> We Have highly skilled Engineers and Works. They are ready to work with you. We are providing Both Road and Construction services for you. 
                     <button className='about_readmore_button'  onClick={()=> window.open("/about-us","_self")}>Read More</button>
                </p>
               </div> 
           
           </div>
       </div>
  
      <div className="get_qoute" onClick={()=>window.open("/contact-us","_self")}>
     <span className="hand_wave">👋 </span> 
             GET A QOUTE
             <span>
                  <FontAwesomeIcon icon={faArrowRight}  className="fa_home_arrowright" />
             </span>
             </div>
  {/* about us company */}
          <h2 style={{fontSize:'1.5rem',textAlign:'center',marginBottom:'50px',fontWeight:'700'}}>ABOUT US</h2>
          
          {/* about home company */}
       <div className='home_about_company'>
     <div className='home_about_company_content_container'>
          <p className="home_about_company_content">
          "we are theni-veerapandi based land promoting and construction company. customer satisfaction and work quality are our first priority. Contact us for more information."
          </p>
          <button className='home_about_readmore_button' onClick={()=> window.open("/about-us","_self")}>Read more</button>
     </div>

     <div className='home_about_company_image'>
      <img src={Founder} className="home_founder_image" alt="the founder of the company"/>
       
     </div>
  </div>

  
   {/*  background images */}
   <div className="home_company_background_image">
          </div>
  </div>
  </>;
}

export default About;
